import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateControllerDirective } from './directive/date-controller.directive';
@NgModule({
  declarations: [DateControllerDirective],
  imports: [
    CommonModule
  ],
  exports: [DateControllerDirective]
})
export class DateControllerModule { }